import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../services/utility.service';
import { TranslateService } from '@ngx-translate/core';
import * as Enums from '../../utils/enums';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
})
export class CookiePolicyComponent implements OnInit {

  urlName: string;
  currentUrl: string;
  cookieInformation: string;

  constructor(
    private readonly utilityService: UtilityService,
    private translate: TranslateService
  ) {
    this.urlName = '/' + Enums.AppRoutes.Booking;
    this.cookieInformation = this.translate.instant("lblCookieInformation");
  }


  public redirectToHome() {
    this.moveNext();
  }

  public moveNext(): void {
    if (this.currentUrl)
      this.urlName = '/' + this.currentUrl;
    this.utilityService.navigateToNext(this.urlName);
  }

  ngOnInit(): void {
    this.currentUrl = localStorage.getItem('currentUrl');
    if (this.currentUrl) {
      const urlParts = this.currentUrl.split('/');
      if (urlParts.length >= 4) {
        this.currentUrl = urlParts[3];
      }
    }
  }

}
